//const baseUrl = 'https://func-octolytics-dev.azurewebsites.net/api'
//const baseUrl = 'https://func-mimovil-dev.azurewebsites.net/api'
//const baseUrlTemp = 'https://octo-dev-function.azurewebsites.net/api'
//const baseUrlTemp = 'https://test-octo.azurewebsites.net/api'
//const baseUrl = 'https://func-inxel-dev.azurewebsites.net/api'

const baseUrl = 'https://func-mexfon-dev.azurewebsites.net/api'

const get = pathUrl => fetch(`${baseUrl}${pathUrl}`).then(res => res.json())

const post = (pathUrl, data) =>
    fetch(`${baseUrl}${pathUrl}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    }).then(res => res.json())

const postFormData = (pathUrl, file) => {
    let formData = new FormData()
    formData.append('file', file, 'baseStations-file.csv')

    return fetch(`${baseUrl}${pathUrl}`, {
        method: 'POST',
        body: formData,
    }).then(res => res.json())
}

const put = (pathUrl, data) =>
    fetch(`${baseUrl}${pathUrl}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    }).then(res => res.json())

const del = (pathUrl, data) =>
    fetch(`${baseUrl}${pathUrl}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    }).then(res => res.json())

/*
const getTemp = pathUrl => fetch(`${baseUrlTemp}${pathUrl}`).then(res => res.json())

const postTemp = (pathUrl, data) =>
    fetch(`${baseUrlTemp}${pathUrl}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    }).then(res => res.json())

const putTemp = (pathUrl, data) =>
    fetch(`${baseUrlTemp}${pathUrl}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    }).then(res => res.json())

const delTemp = (pathUrl, data) =>
    fetch(`${baseUrlTemp}${pathUrl}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    }).then(res => res.json())
*/

export { get, post, postFormData, put, del }
